import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useReactToPrint } from 'react-to-print';

import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-buttons-bs4';
import Header from './Header';
import logo from './images/icons/logo.JPG'; // Import your image here

const ModalViewTenants = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;
//viewPlotsCustomers
  let userCompanyID = localStorage.getItem('companyID')
  if(userCompanyID === 'Admin'){
   userCompanyID = 1;
  }
  userCompanyID = JSON.parse(userCompanyID)

  let userID = localStorage.getItem('userID')
  if(userID === 'Admin'){
    userID = 1;
  }
  userID = JSON.parse(userID)

  let [businessLocationsHouses, setBusinessLocationsHouses] = useState([]);


    useEffect(() => {
      // Create formData object
      const formData = new FormData();
      formData.append("apiType", 'getBusinessLocationHousesOnUploadForm');
      formData.append("companyID", userCompanyID);
      formData.append("location", '');
      // Fetch plot options from the backend using POST method
      axios.post(`${server_app_api_php}/server/index.php`, formData)
        .then(response => {
          setBusinessLocationsHouses(response.data);
        })
        .catch(error => {
         // alert("There was an error fetching the Business Locations!", error);
        });
      }, []);

  const [dataHousesTenants, setDataHousesTenants] = useState({
    columns: [
    { label: 'SN', field: 'sn' },
      { label: 'Location', field: 'businessLocationName' },
      { label: 'Block', field: 'block' },
      { label: 'House Number', field: 'houseNumber' },
      { label: 'Name', field: 'name' },
      { label: 'Date Contract Signed', field: 'dateContractSigned' },
      { label: 'Last Date Paid', field: 'lastDatePaid' },
      { label: 'Rental Price', field: 'rentalPrice' },
      { label: 'Amount Paid', field: 'amountPaid' },
    ],
    rows: [],
  });
  const [totalAmountHousesTenants, setTotalAmountHousesTenants] = useState(0);
  const [filteredDataHousesTenants, setFilteredDataHousesTenants] = useState([]);
  const [entriesHousesTenants, setEntriesHousesTenants] = useState(5); // Number of entries per page
  const [searchValueHousesTenants, setSearchValueHousesTenants] = useState(''); // Search value
  //const [searchValuePlotsDetailed, setSearchValuePlotsDetailed] = useState('');

  const calculateTotalHousesTenants = (rows) => {
    return rows.reduce((sum, row) => sum + parseFloat(row.amountPaid), 0).toFixed(2);
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append('apiType', 'fetchViewHousesTenants');
    formData.append('companyID', userCompanyID);

    const fetchDataHousesTenants = async () => {
      try {
        const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
        const fetchedData = response.data.map((row, index) => ({
          sn: index + 1,
          businessLocationName: row.businessLocationName,
          block: row.block,
          houseNumber: row.houseNumber,
          name: row.name,
          dateContractSigned: row.dateContractSigned,
          lastDatePaid: row.lastDatePaid,
          rentalPrice: row.rentalPrice,
          amountPaid: row.amountPaid,
          rentalsTotalAmountPaid: row.rentalsTotalAmountPaid,
        }));

        setDataHousesTenants((prevState) => ({
          ...prevState,
          rows: fetchedData,
        }));

        setTotalAmountHousesTenants(calculateTotalHousesTenants(fetchedData));
        setFilteredDataHousesTenants(fetchedData); // Initially set all data
      } catch (error) {
        //alert('Internet Error: Failed to fetch data');
      }
    };

    fetchDataHousesTenants();
  }, []);

  const handleTableSearch = (value) => {
    setSearchValueHousesTenants(value);
    const filteredRows = dataHousesTenants.rows.filter((row) => {
      return Object.values(row).some((field) => field.toString().toLowerCase().includes(value.toLowerCase()));
    });
    setFilteredDataHousesTenants(filteredRows.slice(0, entriesHousesTenants));
  };

  const exportPDFHousesTenants = () => {
    const doc = new jsPDF('landscape');
    const pageSize = 100; 
    let pageData = [];

    const searchValueLower = searchValueHousesTenants.trim().toLowerCase();

      const filteredByAllFields = searchValueLower === '' ? filteredDataHousesTenants : filteredDataHousesTenants.filter(row => 
       row.businessLocationName?.toString().toLowerCase().includes(searchValueLower) ||
          row.houseNumber?.toString().toLowerCase().includes(searchValueLower) ||
          row.name?.toString().toLowerCase().includes(searchValueLower) ||
          row.dateContractSigned?.toString().toLowerCase().includes(searchValueLower) ||
          row.lastDatePaid?.toString().toLowerCase().includes(searchValueLower) ||
          row.rentalPrice?.toString().toLowerCase().includes(searchValueLower) ||
          row.amountPaid?.toString().toLowerCase().includes(searchValueLower) ||
          row.rentalsTotalAmountPaid?.toString().toLowerCase().includes(searchValueLower) ||
          row.block?.toString().toLowerCase().includes(searchValueLower)
      );
      
    //for (let i = 0; i < filteredData.length; i += pageSize) {
      //pageData = filteredData.slice(i, i + pageSize);
      
      //for (let i = 0; i < filteredByAllFields.length; i += pageSize) {
      //pageData = filteredByAllFields.slice(i, i + pageSize);
      // Assuming calculateTotal is a function that takes an array of data and returns the total of the amountPaid field
const calculateTotalHousesTenants = (data) => {
  return data.reduce((total, row) => total + parseFloat(row.rentalsTotalAmountPaid), 0);
};

 pageData = filteredByAllFields;

const calculatePageTotalHousesTenants = (rows) => {
  return rows.reduce((total, row) => total + parseFloat(row.raw[8]), 0).toFixed(2);
};

const addPageTotalHousesTenants = (data) => {
  let pageTotal = calculatePageTotalHousesTenants(data.table.body);
  doc.text(`Total: K ${pageTotal}`, data.settings.margin.left + 350, doc.internal.pageSize.height - 10);
};

doc.autoTable({
  head: [['SN', 'Location', 'Block', 'House#', 'Name', 'Date Contract Signed', 'Last Date Paid', 'Rental Price (ZMW)', 
    'Amount Paid (ZMW)']],
  body: pageData.map((row, index) => [
    index + 1,
    row.businessLocationName,
    row.block,
    row.houseNumber,
    row.name,
    row.dateContractSigned,
    row.lastDatePaid,
    row.rentalPrice,
    row.amountPaid
  ]),
  didDrawPage: addPageTotalHousesTenants,
  margin: { bottom: 20 } // Adjust bottom margin to make space for the total text
});

const overallTotal = calculateTotalHousesTenants(filteredByAllFields).toFixed(2);
doc.autoTable({
  head: [['', '', '', '', '', '', '']],
  foot: [['', '', '', 'Total Amount Paid:', overallTotal+"(ZMW)", '', '']],
  startY: doc.lastAutoTable.finalY + 10 // Start a bit after the last table
});


    doc.save('House Tenants statement.pdf');
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
  });
  
  /**********Codes for DataTables Starts Here************/   
  const [DBtableHousesTenants, setDBtableHousesTenants] = useState([]);
  //const [pdfData, setPdfData] = useState([]);
  const [entriesValueHousesTenants, setEntriesValueHousesTenants] = useState(5);
  useEffect(() => {
    fetchDataForTableHousesTenants();
  }, [entriesValueHousesTenants]);

  const fetchDataForTableHousesTenants = async () => {
    const formData = new FormData();
    formData.append('apiType', 'fetchViewHousesTenants');
    formData.append('companyID', userCompanyID);
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
      //alert('API Response Data for Table: ' + JSON.stringify(response.data));

      const processedData = response.data.map(row => ({
        ...row,
        amountPaid: parseFloat(row.amountPaid) || 0
      }));

      setDBtableHousesTenants(processedData);
      //alert('Processed Data for Table: ' + JSON.stringify(processedData));

      setTimeout(() => {
        const table = $('#tableHousesTenants').DataTable({
          footerCallback: function (row, data, start, end, display) {
            const api = this.api();

            const pageTotal = api
              .column(8, { page: 'current' })
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Page Total: ' + pageTotal);

            $(api.column(8).footer()).html(pageTotal.toFixed(2));

            const overallTotal = api
              .column(8)
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Overall Total: ' + overallTotal);

            $('#totalOverallHousesTenants').html(overallTotal.toFixed(2));
          },
          retrieve: true,
          pageLength: entriesValueHousesTenants,
          lengthMenu: [5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 50000, 100000, 500000, 1000000],
          initComplete: function () {
            const api = this.api();
            setSearchValueHousesTenants(api.search());
            setEntriesValueHousesTenants(api.page.len());

            api.on('search.dt', function () {
              setSearchValueHousesTenants(api.search());
            });

            api.on('length.dt', function () {
              setEntriesValueHousesTenants(api.page.len());
            });
          }
        });

        //addTableButtons(table);
      }, 1000);
    } catch (error) {
      //alert('Error fetching data for table: ' + error);
    }
  };
  /**********Codes For DataTables Ends Here****************/


  const [tenantStatement, setTenantStatement] = useState([{ loopedItems: [], nonLoopedItems: {} }]);
  /**************Function To Respond To View Statement From The Main Table Starts Here***********************/
  const viewHousesTenants = tenantID => {
    //console.log('Modal Table Data', tenantID)
    // Assuming responseData is an array of objects
    const loopedItems = tenantID.map(item => item.loopedItems).flat() || [];
    const nonLoopedItems = tenantID.map(item => item.nonLoopedItems) || [];
    setTenantStatement({ loopedItems, nonLoopedItems });
    }
  /**************Function To Respond To View Statement From The Main Table Ends Here***********************/
 
    /**************Function To Respond To Generate PDF From The Main Table Starts Here***********************/
    const viewHousesTenantsFromTheMainTablePdf = tenantID => {
      // Assuming responseData is an array of objects
      const loopedItems = tenantID.map(item => item.loopedItems).flat() || [];
      const nonLoopedItems = tenantID.map(item => item.nonLoopedItems) || [];
      setTenantStatement({ loopedItems, nonLoopedItems });
      generatePDF(loopedItems, nonLoopedItems);
      }
    /**************Function To Respond To Generate PDF From The Main Table Ends Here***********************/

        /**************Function To Respond To Send PDF To Email From The Main Table Starts Here***********************/
        const viewHousesTenantsFromTheMainTableSendEmail = tenantID => {
          // Assuming responseData is an array of objects
          const loopedItems = tenantID.map(item => item.loopedItems).flat() || [];
          const nonLoopedItems = tenantID.map(item => item.nonLoopedItems) || [];
          setTenantStatement({ loopedItems, nonLoopedItems });
          generatePDFAndSendEmail(loopedItems, nonLoopedItems);
          }
        /**************Function To Respond To Send PDF To Email From The Main Table Ends Here***********************/

    
  
    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('en-ZM', { style: 'currency', currency: 'ZMW' }).format(amount);
    };

    const formatCurrencyTable = (amount) => {
      // Convert amount to a number if it's not already
      const number = typeof amount === 'number' ? amount : parseFloat(amount);
      return new Intl.NumberFormat('en-ZM', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number);
    };

    const generatePDF = (loopedItems, nonLoopedItems) => {
      //const { loopedItems, nonLoopedItems } = tenantStatement;
      const doc = new jsPDF('landscape');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const titleText = 'Tenant Statement';
      //const titleX = (pageWidth - doc.getTextWidth(titleText)) / 2;

       // Add image
    const imgWidth = 30; // Set image width
    const imgHeight = 15; // Set image height
    const imgX = (pageWidth - imgWidth) / 2; // Center image horizontally
    const imgY = 5; // Set image position from top
    doc.addImage(logo, 'PNG', imgX, imgY, imgWidth, imgHeight);
  
  // Add title text
  doc.setFont('times new roman', 'bold');
  doc.setFontSize(22);
  const titleX = (pageWidth - doc.getTextWidth(titleText)) / 2;
  const titleY = imgY + imgHeight + 10; // Position title below the image
  doc.text(titleText, titleX, titleY);
  
      if (Array.isArray(nonLoopedItems) && nonLoopedItems.length > 0) {
        const nonLoopedItem = nonLoopedItems[0];
  
        const col1StartY = 40;
        const col2StartY = 40;
        const colWidth = 130; // Column width for text wrapping
  
        doc.setFontSize(12);
        doc.setFont('times new roman', 'normal');
  
      // Column 1
      doc.setFont('times new roman', 'bold');
      doc.text('Location:', 10, col1StartY);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.businessLocationName || '-'}`, 70, col1StartY, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
        doc.text('Block:', 10, col1StartY + 10);
        doc.setFont('times new roman', 'normal');
        doc.text(`${nonLoopedItem.block || '-'}`, 70, col1StartY + 10, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('House Number:', 10, col1StartY + 20);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.houseNumber || '-'}`, 70, col1StartY + 20, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Name:', 10, col1StartY + 30);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.name || '-'}`, 70, col1StartY + 30, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Phone:', 10, col1StartY + 40);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.tenantPhone || '-'}`, 70, col1StartY + 40, { maxWidth: colWidth - 70 });

      // Column 2
      doc.setFont('times new roman', 'bold');
      doc.text('Total Amount Paid:', 160, col2StartY);
      doc.setFont('times new roman', 'normal');
      doc.text(`${formatCurrency(nonLoopedItem.rentalsTotalAmountPaid) || '-'} (ZMW)`, 160 + 50, col2StartY, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Rental Price:', 160, col2StartY + 10);
      doc.setFont('times new roman', 'normal');
      doc.text(`${formatCurrency(nonLoopedItem.rentalPrice) || '-'} (ZMW)`, 160 + 50, col2StartY + 10, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Email:', 160, col2StartY + 20);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.tenantEmail || '-'}`, 160 + 50, col2StartY + 20, { maxWidth: colWidth - 70 });

    doc.setFont('times new roman', 'bold');
      doc.text('Last Date Paid:', 160, col2StartY + 30);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.lastDatePaid || '-'}`, 160 + 50, col2StartY + 30, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Date Contract Signed:', 160, col2StartY + 40);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.dateContractSigned || '-'}`, 160 + 50, col2StartY + 40, { maxWidth: colWidth - 70 });
    } else {
        doc.setFontSize(16);
        doc.text('No items available.', 20, 40);
      }
  
      if (Array.isArray(loopedItems) && loopedItems.length > 0) {
        const tableColumn = ["SN", "Amount (ZMW)", "Date"];
        const tableRows = [];
  
        loopedItems.forEach((item, index) => {
          const rowData = [
            index + 1,
            formatCurrencyTable(item.amountPaid),
            item.datePaid,
          ];
          tableRows.push(rowData);
        });
  
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 100,
          didDrawPage: (data) => {
            // Add page number
            const pageCount = doc.internal.getNumberOfPages();
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.setFontSize(10);
            doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
          }
        });
      }
  
      // Adding page numbers to any additional pages
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
      }
  
      doc.save('Tenant statement.pdf');
    };

    const[tenantsEmail, setTenantsEmail] = useState('');
    const generatePDFAndSendEmail = (loopedItems, nonLoopedItems) => {
      //const { loopedItems, nonLoopedItems } = tenantStatement;
      
      const doc = new jsPDF('landscape');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const titleText = 'Tenant Statement';
      //const titleX = (pageWidth - doc.getTextWidth(titleText)) / 2;

       // Add image
    const imgWidth = 30; // Set image width
    const imgHeight = 15; // Set image height
    const imgX = (pageWidth - imgWidth) / 2; // Center image horizontally
    const imgY = 5; // Set image position from top
    doc.addImage(logo, 'PNG', imgX, imgY, imgWidth, imgHeight);
  
  // Add title text
  doc.setFont('times new roman', 'bold');
  doc.setFontSize(22);
  const titleX = (pageWidth - doc.getTextWidth(titleText)) / 2;
  const titleY = imgY + imgHeight + 10; // Position title below the image
  doc.text(titleText, titleX, titleY);
  
      if (Array.isArray(nonLoopedItems) && nonLoopedItems.length > 0) {
        const nonLoopedItem = nonLoopedItems[0];
        setTenantsEmail(nonLoopedItem.tenantsEmail);
  
        const col1StartY = 40;
        const col2StartY = 40;
        const colWidth = 130; // Column width for text wrapping
  
        doc.setFontSize(12);
        doc.setFont('times new roman', 'normal');
  
        // Column 1
      doc.setFont('times new roman', 'bold');
      doc.text('Location:', 10, col1StartY);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.businessLocationName || '-'}`, 70, col1StartY, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
        doc.text('Block:', 10, col1StartY + 10);
        doc.setFont('times new roman', 'normal');
        doc.text(`${nonLoopedItem.block || '-'}`, 70, col1StartY + 10, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('House Number:', 10, col1StartY + 20);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.houseNumber || '-'}`, 70, col1StartY + 20, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Name:', 10, col1StartY + 30);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.name || '-'}`, 70, col1StartY + 30, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Phone:', 10, col1StartY + 40);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.tenantPhone || '-'}`, 70, col1StartY + 40, { maxWidth: colWidth - 70 });

      // Column 2
      doc.setFont('times new roman', 'bold');
      doc.text('Total Amount Paid:', 160, col2StartY);
      doc.setFont('times new roman', 'normal');
      doc.text(`${formatCurrency(nonLoopedItem.rentalsTotalAmountPaid) || '-'} (ZMW)`, 160 + 50, col2StartY, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Rental Price:', 160, col2StartY + 10);
      doc.setFont('times new roman', 'normal');
      doc.text(`${formatCurrency(nonLoopedItem.rentalPrice) || '-'} (ZMW)`, 160 + 50, col2StartY + 10, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Email:', 160, col2StartY + 20);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.tenantEmail || '-'}`, 160 + 50, col2StartY + 20, { maxWidth: colWidth - 70 });

    doc.setFont('times new roman', 'bold');
      doc.text('Last Date Paid:', 160, col2StartY + 30);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.lastDatePaid || '-'}`, 160 + 50, col2StartY + 30, { maxWidth: colWidth - 70 });

      doc.setFont('times new roman', 'bold');
      doc.text('Date Contract Signed:', 160, col2StartY + 40);
      doc.setFont('times new roman', 'normal');
      doc.text(`${nonLoopedItem.dateContractSigned || '-'}`, 160 + 50, col2StartY + 40, { maxWidth: colWidth - 70 });
    } else {
        doc.setFontSize(16);
        doc.text('No items available.', 20, 40);
      }
  
      if (Array.isArray(loopedItems) && loopedItems.length > 0) {
        const tableColumn = ["SN", "Amount (ZMW)", "Date"];
        const tableRows = [];
  
        loopedItems.forEach((item, index) => {
          const rowData = [
            index + 1,
            formatCurrencyTable(item.amountPaid),
            item.datePaid,
          ];
          tableRows.push(rowData);
        });
  
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 100,
          didDrawPage: (data) => {
            // Add page number
            const pageCount = doc.internal.getNumberOfPages();
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.setFontSize(10);
            doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
          }
        });
      }
  
      // Adding page numbers to any additional pages
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
      }
  
      //doc.save('customer statement.pdf');
   
     // const doc = new jsPDF('landscape');
      
      // Your PDF generation code here
      // ...
    
      // Convert PDF to Blob
      const pdfOutput = doc.output('blob');
    
      // Create FormData to send to the server
      const formData = new FormData();
      formData.append('file', pdfOutput, 'tenant statement.pdf');
      formData.append('apiType', 'sendEmailCustomerStatementPDF');
      formData.append('email', tenantsEmail);
    
      // Send the PDF to your server
      axios.post(`${server_app_api_php}/server/index.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        alert('Email sent successfully', response.data);
      })
      .catch(error => {
        alert('Error sending email');
      });
    };
  
    const { loopedItems, nonLoopedItems } = tenantStatement;

    const sendEmailHousesLoginCredentials = id => {
        // Create FormData to send to the server
        const formData = new FormData();
        formData.append('apiType', 'sendEmailHousesLoginCredentials');
        formData.append('id', id);    
        axios.post(`${server_app_api_php}/server/index.php`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          alert(response.data);
        })
        .catch(error => {
          alert('Error sending Loggin Credentials');
        });  
    }
   
    const comfirmTenantsAvailability = id => {
        // Create FormData to send to the server
        const formData = new FormData();
        formData.append('apiType', 'comfirmClientAvailability');
        formData.append('customerID', id);
        formData.append('customerType', 'Houses');
        axios.post(`${server_app_api_php}/server/payment_remindersEmailList.php`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          alert(response.data);
        })
        .catch(error => {
          alert('Error sending Comfirmation');
        });  
    }

  return (
    <>
     <Header />
    
   <main class="bg-white">   
   <hr />
    <div className="container-fluid mt-5" style={{ overflowX: 'auto' }}>

    {/**************Modal For Plot Customer Statement Starts Here****************/}
    <div className="modal fade" id="modalViewHousesTenants" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
          aria-hidden="true">
          <div className="modal-dialog modal-fluid modal-notify modal-success" role="document">
            {/* Content */}
            <div className="modal-content">
              {/* Header */}
              <div className="modal-header">
                <p className="heading lead">View Tenants Details</p>

                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" className="white-text">&times;</span>
                </button>
              </div>

              {/* Body */}
              <div className="modal-body ">
               
			    {/* Second column */}
          <div className="col-md-12 col-lg-12 col-xl-12 mb-md-0 mb-5 ">

            {/* Card */}
            <div className="card profile-card ">


              <div className="card-body pt-0 mt-0">                				
                        
              <div className='mt-5'>
                <div className='row'>
                <div className='col-md-6 text-left'>
              <a type="button" className="btn btn-outline-success waves-effect" 
               onClick={() => {
                generatePDFAndSendEmail(loopedItems, nonLoopedItems)
              }}
              >Send Email</a>
              </div>
              <div className='col-md-6 text-right'>
              <a type="button" className="btn btn-outline-success waves-effect" 
              onClick={() => {
                generatePDF(loopedItems, nonLoopedItems)
              }}
              >PDF</a>
              </div>
              </div>

              <div className='text-center'>
          <img src={logo} alt="Logo" style={{ width: '120px', height: '60px' }} />
          <h1 className='font-weight-bold text-uppercase'>Tenant Statement</h1>
        </div>
                <hr />
                        {/* Display only the first non-looped item */}
                        {Array.isArray(nonLoopedItems) && nonLoopedItems.length > 0 && (
                            <div className='row'>
                             
                             <div className='col-md-6 text-left'>
                                <p> <span className='font-weight-bold text-uppercase'> Business Location Name:</span>  {nonLoopedItems[0]?.businessLocationName || '-'}</p>
                                <p><span className='font-weight-bold text-uppercase'>Block:</span> {nonLoopedItems[0]?.block || '-'}</p>
                                <p> <span className='font-weight-bold text-uppercase'>House Number:</span> {nonLoopedItems[0]?.houseNumber || '-'}</p>
                                <p><span className='font-weight-bold text-uppercase'>Name:</span> {nonLoopedItems[0]?.name || '-'}</p>                                
                                <p> <span className='font-weight-bold text-uppercase'>Tenant Phone:</span> {nonLoopedItems[0]?.tenantPhone || '-'}</p>                                
                                </div>
                                <div className='col-md-6 text-left'>
                                <p><span className='font-weight-bold text-uppercase'>Total Amount Paid:</span> {formatCurrency(nonLoopedItems[0]?.rentalsTotalAmountPaid)+' (ZMW)' || '-'}</p>
                                <p><span className='font-weight-bold text-uppercase'>Rental Price:</span> {formatCurrency(nonLoopedItems[0]?.rentalPrice)+' (ZMW)' || '-'}</p>
                                <p><span className='font-weight-bold text-uppercase'>Tenant Email:</span> {nonLoopedItems[0]?.tenantEmail || '-'}</p>
                                <p><span className='font-weight-bold text-uppercase'>Last Date Paid:</span> {nonLoopedItems[0]?.lastDatePaid || '-'}</p>
                                <p><span className='font-weight-bold text-uppercase'>Date Contract Signed:</span> {nonLoopedItems[0]?.dateContractSigned || '-'}</p>
                                </div>
                            </div>
                        )}
                        {Array.isArray(nonLoopedItems) && nonLoopedItems.length === 0 && <p>No items available.</p>}
                    </div>

             <hr className='my-5'/>
				<div className="row">
				
<table id="tableViewHousesTenants"  className="table table-striped table-bordered table-hover table-sm ">
	<thead className="ocean blue-gradient white-text">
                    <tr>
  <th className="font-weight-bold "><strong>SN</strong></th>
                      <th className="font-weight-bold "><strong>Amount (ZMW)</strong></th>
                      <th className="font-weight-bold "><strong>Date</strong></th>
                    </tr>
                  </thead>
	
	<tbody>
  {loopedItems ? (
                            <>
  {loopedItems.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{formatCurrencyTable(val.amountPaid)}</td>
                            <td>{val.datePaid}</td>
                            </tr>

                          ))}

</>
                        ) : (
                            <p>Loading  items...</p>
                        )}
    
	</tbody>
	
	<tfoot className='form-header text-center black-text'>
                       
                      </tfoot>
					  
	</table>
	
</div>
				
			</div>

            </div>
            {/* Card */}

          </div>
          {/* Second column */}
			   
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <div className='row'>
                  <div className='col-md-6 left'>
                  <a type="button" className="btn btn-outline-success waves-effect"  onClick={() => {
                generatePDF(loopedItems, nonLoopedItems)
              }}>PDF</a>
                  </div>
                  <div className='col-md-6 text-right'>
                  <a type="button" className="btn btn-outline-success waves-effect" data-dismiss="modal">Close</a>
                  </div>
                </div>
              </div>
            </div>
            {/* Content */}
          </div>
        </div>

    {/**************Modal For Plot Customer Statement Ends Here *****************/}
  
<div class="view view-cascade gradient-card-header  ocean blue-gradient">
                  <h2 class="h2-responsive mb-0 font-weight-bold white-text py-5">RIDGEHILL REAL ESTATE</h2>
                </div>      
     
      <section className="fixed-sn white-skin">
          <div className="d-flex justify-content-center align-items-center">
            <div className="">
              <div className="card mt-5">
                <div className="card-body">
                  <div className="">
                    <br />
                    <h2 className="form-header white-text ocean blue-gradient text-uppercase">View Tenants Details</h2>

                    <center>
                    <div id="filterTopCriteria">
                    <button onClick={exportPDFHousesTenants} className="btn btn-primary me-2">PDF</button>
                      </div>
                    </center>
                    <table id="tableHousesTenants" className="table table-striped table-bordered table-hover table-sm">
                      <thead className="form-header text-uppercase ocean blue-gradient">
                        <tr>
                    <th>S/N</th>
                    <th><strong>Location</strong></th>
                    <th><strong>Block</strong></th>
                      <th><strong>House#</strong></th>
                      <th><strong>Name</strong></th>
                      <th><strong>Date Contract Signed</strong></th>
                      <th><strong>Last Date Paid</strong></th>
                      <th><strong>Rentals Price</strong></th>
                      <th><strong>Amount Paid</strong></th>
                      <th><strong>Action</strong></th>
                        </tr>
                      </thead>
                      <tbody>
                        {DBtableHousesTenants.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val.businessLocationName}</td>
                            <td>{val.block}</td>
                            <td>{val.houseNumber}</td>
                            <td>{val.name}</td>
                            <td>{val.dateContractSigned}</td>
                            <td>{val.lastDatePaid}</td>
                            <td>{val.rentalPrice}</td>
                            <td>{val.amountPaid}</td>
                            <td>
                            <ul class="nav navbar-nav nav-flex-icons ml-auto" >
	  <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle waves-effect" href="" id="userDropdown" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="clearfix d-none d-sm-inline-block"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown" style={{width: '500%' }}>
			
<a class="dropdown-item"
    data-toggle='modal'
    data-target='#modalViewHousesTenants'
    onClick={() => {
      viewHousesTenants(val.tenantStatement)
    }}
><span class = "fa fa-envelope"></span>View Statement</a>
<a class="dropdown-item"
    onClick={() => {
      viewHousesTenantsFromTheMainTableSendEmail(val.tenantStatement)
    }}
><span class = "fa fa-eye"></span>Send Statement To Email</a>
<a class="dropdown-item"
    onClick={() => {
      viewHousesTenantsFromTheMainTablePdf(val.tenantStatement)
    }}
><span class = "fa fa-eye"></span>PDF Tenant Statement</a>
<a class="dropdown-item"
onClick={() => {
    comfirmTenantsAvailability(val.tenantsID)
  }}
><span class = "fa fa-check"></span>Confirm For Automated Payment Reminder</a>
<a class="dropdown-item"
onClick={() => {
    sendEmailHousesLoginCredentials(val.tenantsID)
  }}
><span class = "fa fa-envelope"></span>Send Login Credentials</a>			 
<a class="dropdown-item" hidden><span class = "fa fa-coins"></span>Mark Completed Payments</a>			 


           </div>
          </li></ul>

                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot className="form-header text-center ocean blue-gradient">
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>TOTAL</th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr>
                        <th></th>
                        <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>
                            <div className="text-white text-uppercase">
                              <span>Over Total Amount</span>
                            </div>
                          </th>
                          <th>
                          <div className="text-white">
                              <span id="totalOverallHousesTenants"></span>
                            </div>
                          </th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      <div hidden>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <CSVLink
            data={filteredDataHousesTenants}
            headers={dataHousesTenants.columns.map((col) => ({ label: col.label, key: col.field }))}
            filename="tenants statement.csv"
            className="btn btn-primary me-2"

            hidden
          >
            CSV
          </CSVLink>
          <button onClick={exportPDFHousesTenants} className="btn btn-primary me-2">PDF</button>
          <button hidden onClick={handlePrint} className="btn btn-primary">Print</button>
        </div>
        <div className="d-flex align-items-center">
          <label htmlFor="entriesSelect" className="me-2">Show entries:</label>
          <select
            id="entriesSelect"
            value={entriesHousesTenants}
            onChange={(e) => setEntriesHousesTenants(Number(e.target.value))}
            className="form-select me-3"
            style={{ width: '75px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
          <input
            type="text"
            placeholder="Search..."
            value={searchValueHousesTenants}
            onChange={(e) => handleTableSearch(e.target.value)}
            className="form-control"
            style={{ width: '200px' }}
          />
        </div>
      </div>
      </div>
      <hr />
    </div>
    </main>

    </>
  );
};

export default ModalViewTenants;
